<template>
  <div class="generalEstimate">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.Brief_Report') }}
    </div>
    <div class="generalEstimate-con">
      <!-- <div> -->
      <a-form>
        <a-form-item
          :label="$tc('lang.ReportsDetail.Overall_Conclusion')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-radio-group v-model="details.ireportConclusion">
            <a-radio value="1">{{ $tc('lang.ReportsDetail.PASS') }}</a-radio>
            <a-radio value="2">{{ $tc('lang.ReportsDetail.PENDING') }}</a-radio>
            <a-radio value="3">{{ $tc('lang.ReportsDetail.FAIL') }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item
          label="检验标准"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-input v-model="dataForm.biao"></a-input>
        </a-form-item> -->
        <a-form-item
          :label="$tc('lang.ReportsDetail.Brief_Findings')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 15 }"
        >
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.ReportsDetail.Bulk_Summary')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="details.ireportIsbulk">
                <a-radio value="1">{{
                  $tc('lang.ReportsDetail.Pass')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.ReportsDetail.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.ReportsDetail.Fail')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="details.ireportBulkinfo"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.ReportsDetail.Packing_Information')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="details.ireportIspack">
                <a-radio value="1">{{
                  $tc('lang.ReportsDetail.Pass')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.ReportsDetail.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.ReportsDetail.Fail')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="details.ireportPack"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.ReportsDetail.Workmanship')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="details.ireportIsproductopera">
                <a-radio value="1">{{
                  $tc('lang.ReportsDetail.Pass')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.ReportsDetail.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.ReportsDetail.Fail')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="details.ireportProductopera"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.ReportsDetail.ProductDetails')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="details.ireportIsproductdetail">
                <a-radio value="1">{{
                  $tc('lang.ReportsDetail.Pass')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.ReportsDetail.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.ReportsDetail.Fail')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="details.ireportProductdetail"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.ReportsDetail.Data_Measurement_Field_Test')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="details.ireportIsfieldtest">
                <a-radio value="1">{{
                  $tc('lang.ReportsDetail.Pass')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.ReportsDetail.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.ReportsDetail.Fail')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="details.ireportFieldtest"
              ></a-input>
            </span>
          </div>
          <div class="spanGroup">
            <span class="span1">{{
              $tc('lang.ReportsDetail.Defects_Disposal')
            }}</span>
            <span class="span2">
              <a-radio-group v-model="details.ireportIsdefecthandle">
                <a-radio value="1">{{
                  $tc('lang.ReportsDetail.Pass')
                }}</a-radio>
                <a-radio value="2">{{
                  $tc('lang.ReportsDetail.Pending')
                }}</a-radio>
                <a-radio value="3">{{
                  $tc('lang.ReportsDetail.Fail')
                }}</a-radio>
              </a-radio-group>
            </span>
            <span class="span3">
              <a-input
                :placeholder="$tc('lang.ReportsDetail.Description')"
                v-model="details.ireportDefecthandle"
              ></a-input>
            </span>
          </div>
        </a-form-item>
        <a-form-item
          :label="$tc('lang.ReportsDetail.Customer_Requirements')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <a-textarea
            v-model="details.ireportTestremark"
            :rows="4"
            :placeholder="$tc('lang.ReportsDetail.Reply')"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    details: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.report.details));
      },
      //   set(val) {
      //     console.log(val);

      //     // this.$store.commit('report/save', { details: val });
      //   },
    },
    imgList: {
      get() {
        return this.$store.state.report.imgList;
      },
      set(val) {
        this.$store.commit('report/save', { imgList: val });
      },
    },
  },
};
</script>
<style lang="less">
.generalEstimate {
  .generalEstimate-con {
    display: flex;
    form {
      flex-grow: 1;
      .ant-form-item-label {
        text-align: left;
        padding-left: 20px;
      }
      .spanGroup {
        display: flex;
        .span1 {
          width: 130px;
        }
        .span2 {
          margin: 0 40px;
        }
        .span3 {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
